import React from 'react';
import { motion } from 'framer-motion';
interface FadeInProps {
  children: React.ReactNode;
  delay?: number;
  duration?: number;
  className?: string;
}
export const FadeIn = ({
  children,
  delay = 0,
  duration = 0.5,
  className
}: FadeInProps) => {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-57" data-mp="1zwu7opciwtpn">
      {children}
    </motion.div>;
};